import React, { useEffect, useState } from 'react';
import AsyncCreatableSelect from 'react-select/async-creatable';
import { Country, State, City } from 'country-state-city';

const CountryStateCitySearch = ({ handleChangeOrg, filterObj, setFilterObj, setIsInitial }) => {
    const [selectedOptions, setSelectedOptions] = useState([]);

    const defaultOptions = Country.getAllCountries()
        .slice(0, 10)
        .map((c) => ({
            label: `${c.name}`,
            value: `${c.name}`,
            type: 'country',
            meta: c,
        }));

    const loadOptions = (inputValue, callback) => {
        if (!inputValue || inputValue.length < 2) {
            callback(defaultOptions);
            return;
        }

        const lower = inputValue.toLowerCase();

        const cityMatches = City.getAllCities()
            .filter((ci) => ci.name.toLowerCase().includes(lower))
            .slice(0, 30)
            .map((ci) => ({
                label: `${ci.name}, ${ci.countryCode}`,
                value: `${ci.name}`,
                type: 'city',
                meta: ci,
            }));

        const stateMatches = State.getAllStates()
            .filter((s) => s.name.toLowerCase().includes(lower))
            .slice(0, 20)
            .map((s) => ({
                label: `${s.name}, ${s.countryCode}`,
                value: `${s.name}`,
                type: 'state',
                meta: s,
            }));

        const countryMatches = Country.getAllCountries()
            .filter((c) => c.name.toLowerCase().includes(lower))
            .slice(0, 10)
            .map((c) => ({
                label: `${c.name}`,
                value: `${c.name}`,
                type: 'country',
                meta: c,
            }));

        callback([...cityMatches, ...stateMatches, ...countryMatches]);
    };

    // useEffect(() => {
    //     handleChangeOrg(selectedOptions)
    // }, [selectedOptions])

    const handleLocation = (e) => {
        setIsInitial(true);
        // const isChecked = e.target.checked;
        setFilterObj(prev => ({
            ...prev,
            person_locations: e
            // person_titles: isChecked ? [...prev.person_titles, value]
            //     : prev.person_titles.filter(item => item !== value)
        }));
    }

    return (
        // <>not in use</>
        <AsyncCreatableSelect
            isMulti
            cacheOptions
            defaultOptions={defaultOptions}
            loadOptions={loadOptions}
            // onChange={setSelectedOptions}
            // value={selectedOptions}
            onChange={handleLocation}
            value={filterObj.person_locations}
            placeholder="city, state or country"
            noOptionsMessage={() => 'No match found'}
            className="basic-multi-select"
        />
    );
};

export default CountryStateCitySearch;
